import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { trackAddToCart } from '../lib/metaPixel';
export function Products() {
  return <section id="productos" className="py-24 bg-white" data-id="element-147">
      <div className="max-w-7xl mx-auto px-6 lg:px-12" data-id="element-148">
        <motion.div className="text-center max-w-3xl mx-auto mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-149">
          <h2 className="font-display text-4xl lg:text-5xl font-bold text-brand-charcoal mb-4" data-id="element-150">
            Nuestras Guías Digitales
          </h2>
          <p className="text-lg text-brand-gray" data-id="element-151">
            Cada guía es un método completo, paso a paso, basado en ciencia.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto" data-id="element-152">
          {/* Card 1 — Resetea tu Cortisol */}
          <motion.div className="bg-white rounded-2xl overflow-hidden shadow-xl shadow-black/5 border border-gray-100 flex flex-col group hover:-translate-y-1 transition-transform duration-300" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} data-id="element-153">
            <div className="h-2 w-full bg-brand-mint" data-id="element-154"></div>
            <div className="relative h-64 overflow-hidden" data-id="element-155">
              <img src="https://cdn.magicpatterns.com/uploads/1KyCHKkiTBw5UTTQ1qAz83/ChatGPT_Image_7_jun_2026,_05_30_33_p.m..png" alt="Mujer latina en calma respirando al aire libre con luz dorada del atardecer" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" data-id="element-156" />
              <div className="absolute top-4 left-4 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full text-xs font-bold tracking-wide text-brand-emerald shadow-sm" data-id="element-157">
                NUEVO ✨
              </div>
            </div>

            <div className="p-8 flex flex-col flex-grow" data-id="element-158">
              <h3 className="font-display text-2xl lg:text-3xl font-bold text-brand-charcoal mb-3" data-id="element-159">
                Resetea tu Cortisol en 21 Días
              </h3>
              <p className="text-brand-gray mb-6 min-h-[3rem]" data-id="element-160">
                Recupera tu energía y transforma tu salud hormonal naturalmente
              </p>

              <ul className="space-y-3 mb-8 flex-grow" data-id="element-161">
                <li className="flex items-start gap-3" data-id="element-162">
                  <CheckCircle2 className="w-5 h-5 text-brand-mint shrink-0 mt-0.5" data-id="element-163" />
                  <span className="text-brand-charcoal text-sm" data-id="element-164">
                    Duermes profundo desde semana 1
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-165">
                  <CheckCircle2 className="w-5 h-5 text-brand-mint shrink-0 mt-0.5" data-id="element-166" />
                  <span className="text-brand-charcoal text-sm" data-id="element-167">
                    Energía natural sin café
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-168">
                  <CheckCircle2 className="w-5 h-5 text-brand-mint shrink-0 mt-0.5" data-id="element-169" />
                  <span className="text-brand-charcoal text-sm" data-id="element-170">
                    Grasa abdominal que se reduce
                  </span>
                </li>
              </ul>

              <div className="flex items-center justify-between mt-auto pt-6 border-t border-gray-100" data-id="element-171">
                <span className="font-display text-2xl font-bold text-brand-charcoal" data-id="element-172">
                  $9.99
                </span>
                <a href="https://reseteatucortisol.elcodigodelbienestar.com" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart({
                content_name: 'Resetea tu Cortisol en 21 Días',
                value: 9.99
              })} className="inline-flex items-center justify-center bg-brand-emerald text-white px-6 py-3 rounded-lg font-medium hover:bg-emerald-900 transition-colors" data-id="element-173">
                  Quiero esta guía &rarr;
                </a>
              </div>
            </div>
          </motion.div>

          {/* Card 2 — El Código del Sueño Profundo */}
          <motion.div className="bg-white rounded-2xl overflow-hidden shadow-xl shadow-black/5 border border-gray-100 flex flex-col group hover:-translate-y-1 transition-transform duration-300" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-174">
            <div className="h-2 w-full" style={{
            backgroundColor: '#1A237E'
          }} data-id="element-175"></div>
            <div className="relative h-64 overflow-hidden" data-id="element-176">
              <img src="https://cdn.magicpatterns.com/uploads/fPuiiTUkdqFrV3g53Fx74d/ChatGPT_Image_7_jun_2026,_02_56_31_p.m..png" alt="Hombre latino durmiendo profundamente en una habitación tranquila con luz azulada" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" data-id="element-177" />
              <div className="absolute top-4 left-4 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full text-xs font-bold tracking-wide shadow-sm" style={{
              color: '#1A237E'
            }} data-id="element-178">
                NUEVO 🌙
              </div>
            </div>

            <div className="p-8 flex flex-col flex-grow" data-id="element-179">
              <h3 className="font-display text-2xl lg:text-3xl font-bold text-brand-charcoal mb-3" data-id="element-180">
                El Código del Sueño Profundo
              </h3>
              <p className="text-brand-gray mb-6 min-h-[3rem]" data-id="element-181">
                Duerme 7 horas reales en 14 días sin pastillas ni apps
              </p>

              <ul className="space-y-3 mb-8 flex-grow" data-id="element-182">
                <li className="flex items-start gap-3" data-id="element-183">
                  <CheckCircle2 className="w-5 h-5 text-brand-mint shrink-0 mt-0.5" data-id="element-184" />
                  <span className="text-brand-charcoal text-sm" data-id="element-185">
                    Sin pastillas ni suplementos costosos
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-186">
                  <CheckCircle2 className="w-5 h-5 text-brand-mint shrink-0 mt-0.5" data-id="element-187" />
                  <span className="text-brand-charcoal text-sm" data-id="element-188">
                    Resultados desde la primera semana
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-189">
                  <CheckCircle2 className="w-5 h-5 text-brand-mint shrink-0 mt-0.5" data-id="element-190" />
                  <span className="text-brand-charcoal text-sm" data-id="element-191">
                    Método respaldado por ciencia
                  </span>
                </li>
              </ul>

              <div className="flex items-center justify-between mt-auto pt-6 border-t border-gray-100" data-id="element-192">
                <span className="font-display text-2xl font-bold text-brand-charcoal" data-id="element-193">
                  $9.99
                </span>
                <a href="https://dormirprofundo.elcodigodelbienestar.com" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart({
                content_name: 'El Código del Sueño Profundo',
                value: 9.99
              })} className="inline-flex items-center justify-center bg-brand-emerald text-white px-6 py-3 rounded-lg font-medium hover:bg-emerald-900 transition-colors" data-id="element-194">
                  Quiero esta guía &rarr;
                </a>
              </div>
            </div>
          </motion.div>

          {/* Card 3 — Desintoxica tu Mente */}
          <motion.div className="bg-white rounded-2xl overflow-hidden shadow-xl shadow-black/5 border border-gray-100 flex flex-col group hover:-translate-y-1 transition-transform duration-300" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} data-id="element-195">
            <div className="h-2 w-full bg-brand-salmon" data-id="element-196"></div>
            <div className="relative h-64 overflow-hidden" data-id="element-197">
              <img src="https://cdn.magicpatterns.com/uploads/xeVWNXCavTGBwqsnD5Ybmu/ChatGPT_Image_7_jun_2026,_02_53_12_p.m..png" alt="Mujer latina meditando en calma en un espacio luminoso con plantas" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" data-id="element-198" />
              <div className="absolute top-4 left-4 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full text-xs font-bold tracking-wide shadow-sm" style={{
              color: '#C2452B'
            }} data-id="element-199">
                NUEVO 🧘
              </div>
            </div>

            <div className="p-8 flex flex-col flex-grow" data-id="element-200">
              <h3 className="font-display text-2xl lg:text-3xl font-bold text-brand-charcoal mb-3" data-id="element-201">
                Desintoxica tu Mente en 21 Días
              </h3>
              <p className="text-brand-gray mb-6 min-h-[3rem]" data-id="element-202">
                Libera tu mente del ruido y recupera tu claridad interior
              </p>

              <ul className="space-y-3 mb-8 flex-grow" data-id="element-203">
                <li className="flex items-start gap-3" data-id="element-204">
                  <CheckCircle2 className="w-5 h-5 text-brand-mint shrink-0 mt-0.5" data-id="element-205" />
                  <span className="text-brand-charcoal text-sm" data-id="element-206">
                    Reduce la sobrecarga mental
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-207">
                  <CheckCircle2 className="w-5 h-5 text-brand-mint shrink-0 mt-0.5" data-id="element-208" />
                  <span className="text-brand-charcoal text-sm" data-id="element-209">
                    Más claridad y enfoque diario
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-210">
                  <CheckCircle2 className="w-5 h-5 text-brand-mint shrink-0 mt-0.5" data-id="element-211" />
                  <span className="text-brand-charcoal text-sm" data-id="element-212">
                    Plan práctico de 21 días
                  </span>
                </li>
              </ul>

              <div className="flex items-center justify-between mt-auto pt-6 border-t border-gray-100" data-id="element-213">
                <span className="font-display text-2xl font-bold text-brand-charcoal" data-id="element-214">
                  $19.99
                </span>
                <a href="https://desintoxicatumente.elcodigodelbienestar.com" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart({
                content_name: 'Desintoxica tu Mente en 21 Días',
                value: 19.99
              })} className="inline-flex items-center justify-center bg-brand-emerald text-white px-6 py-3 rounded-lg font-medium hover:bg-emerald-900 transition-colors" data-id="element-215">
                  Quiero esta guía &rarr;
                </a>
              </div>
            </div>
          </motion.div>
        </div>

        <motion.div className="text-center mt-12" initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} data-id="element-216">
          <p className="text-brand-gray italic" data-id="element-217">Más guías en camino... 🌿</p>
        </motion.div>
      </div>
    </section>;
}